import { Button, Icon, useDebounce } from "shared";
import * as React from 'react';
import { ReactNode, useEffect, useState } from "react";
import { Paper, Popper } from '@mui/material';
import styles from './burger-menu.module.scss';

export interface IBurgerMenuItem {
    element: ReactNode;
    onClick?: () => void;

}

interface IMenuProps {
    menuItems: IBurgerMenuItem[];
    popoverClassName?: string;
    anchorClassName?: string;
}

export const BurgerMenu: React.FC<IMenuProps> = React.memo(({
                                                                menuItems,
                                                                popoverClassName,
                                                                anchorClassName
                                                            }) => {
    const anchorRef = React.useRef(null);
    const [open, setOpen] = useState<boolean>(false);
    const [hovered, setHovered] = useState<boolean>(false);
    const debounceHovered = useDebounce(hovered, 500);
    const debounceOpen = useDebounce(open, 100);

    useEffect(() => {
        if (!debounceHovered) {
            setOpen(false);
        }
    }, [debounceHovered]);

    const onMenuItemClick = (item: IBurgerMenuItem) => {
        item.onClick && item.onClick();
        setOpen(false);
    }

    return (
        <>
            <div onMouseEnter={() => setHovered(true)}
                 onMouseLeave={() => setHovered(false)}>
                <Button
                    onClick={() => setOpen(true)}
                    className={styles.btnClassName}>
                    <div className={anchorClassName ? anchorClassName : styles.anchor} ref={anchorRef}></div>

                    <Icon glyph="menu" size="m"
                          className={styles.icon}

                    />


                </Button>
            </div>
            <Popper
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                open={debounceOpen}
                anchorEl={anchorRef.current}
                className={popoverClassName ? popoverClassName : styles.popper}>
                <Paper
                    className={styles.popoverContainer}
                    elevation={1}
                >
                    {menuItems.map((item, index) => (
                        <div key={index} className={styles.menuItem} onClick={() => onMenuItemClick(item)}>{item.element}</div>
                    ))}
                </Paper>
            </Popper>
        </>
    );
});
